import Controller from '~/controllers/application_controller';

export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }
}
